import { toMoney } from "shared/utils";
import {
  ReverifyCanceledActivity,
  ReverifyCompletedActivity,
  ReverifyRequestedActivity
} from "../types";
import { getFullName } from "shared/utils/get-full-name";

export const ReverifyCanceled = ({
  activityItem
}: {
  activityItem: ReverifyCanceledActivity;
}) => {
  return (
    <div>
      <h2 className="text-base text-content-1000 mb-2">
        <span className="font-bold">Income source re-verification</span> was
        canceled by {activityItem.author.name}
      </h2>
      <p className="text-sm text-content-400">
        for{" "}
        {activityItem.details.contact.first_name
          ? getFullName({
              firstName: activityItem.details.contact.first_name,
              lastName: activityItem.details.contact.last_name,
              middleName: activityItem.details.contact.middle_name,
              short: true
            })
          : activityItem.details.contact.email || "applicant"}{" "}
        — Income source: {activityItem.details.income.name}
      </p>
    </div>
  );
};

export const ReverifyRequested = ({
  activityItem
}: {
  activityItem: ReverifyRequestedActivity;
}) => {
  return (
    <div>
      <h2 className="text-base text-content-1000 mb-2">
        <span className="font-bold">Income source re-verification</span> was
        initiated by {activityItem.author.name}
      </h2>
      <p className="text-sm text-content-400">
        for{" "}
        {activityItem.details.contact.first_name
          ? getFullName({
              firstName: activityItem.details.contact.first_name,
              lastName: activityItem.details.contact.last_name,
              middleName: activityItem.details.contact.middle_name,
              short: true
            })
          : activityItem.details.contact.email || "applicant"}{" "}
        — Income source: {activityItem.details.income.name}
      </p>
    </div>
  );
};

export const ReverifyCompleted = ({
  activityItem
}: {
  activityItem: ReverifyCompletedActivity;
}) => {
  return (
    <div className="w-full">
      <h2 className="text-base text-content-1000 mb-2">
        <span className="font-bold">Income source re-verification</span> was
        completed
      </h2>
      <p className="text-sm text-content-400 border-b border-alpha-40 mb-2 pb-2">
        for{" "}
        {activityItem.details.contact.first_name
          ? getFullName({
              firstName: activityItem.details.contact.first_name,
              lastName: activityItem.details.contact.last_name,
              middleName: activityItem.details.contact.middle_name,
              short: true
            })
          : activityItem.details.contact.email || "applicant"}{" "}
        — Income source: {activityItem.details.income.name}
      </p>

      <ul className="space-y-2 list-disc pl-4 text-content-400 text-sm">
        <li>
          Gross monthly income: updated from{" "}
          <span className="font-medium">
            {toMoney(activityItem.details.previous_gross_monthly || 0)}
          </span>{" "}
          to{" "}
          <span className="font-medium">
            {toMoney(activityItem.details.current_gross_monthly || 0)}
          </span>
        </li>

        <li>
          Net monthly income: updated from{" "}
          <span className="font-medium">
            {toMoney(activityItem.details.previous_net_monthly || 0)}
          </span>{" "}
          to{" "}
          <span className="font-medium">
            {toMoney(activityItem.details.current_net_monthly || 0)}
          </span>
        </li>
      </ul>
    </div>
  );
};
